var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass:
        "product-item__quick-shop-button--custom active btn btn--primary",
      attrs: {
        type: "button",
        "data-quick-add": _vm.product.handle,
        "aria-expanded": "false",
        "aria-controls": "cart-flyout-drawer"
      }
    },
    [_c("span", [_vm._v(_vm._s(_vm.quickShopText))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }